import React from 'react';
import { getUserRoleLabel } from 'js/constants/userRoles';

export const columns = [
  {
    name: 'Data Custodian',
    field: 'full_name',
  },
  {
    name: 'Email',
    field: 'email',
  },
  {
    name: 'Org Role',
    field: 'access_role',
    renderRow(row) {
      return getUserRoleLabel(row.access_role);
    },
  },
];
